import QueryEditor from './QueryEditor';

export default QueryEditor;
